import React from "react";

const FreeTierUpgradeMessage = ({ amplitudeKey, signupPath }) => {
  return (
    <div className="body-2 notice">
      <span>
        You’ve used your free answer. I hope it was helpful! You can get 250
        answers each month (plus so much more) by{" "}
        <a data-amplitude={amplitudeKey} href={signupPath}>
          upgrading to LitCharts A<sup>+</sup>!
        </a>
      </span>
    </div>
  );
};

export default FreeTierUpgradeMessage;
